export enum SettingsCompanyPreferencesDataEventObjectsEnum {
  // Smart QA Scorecard.
  SMART_QA_SCORECARD_CREATE = 'smart_qa_scorecard_create',
  SMART_QA_SCORECARD_CRITERIA_ADD = 'smart_qa_scorecard_criteria_add',
  SMART_QA_SCORECARD_CRITERIA_EDIT = 'smart_qa_scorecard_criteria_edit',
  SMART_QA_SCORECARD_CRITERIA_VARIANT = 'smart_qa_scorecard_criteria_variant',
  SMART_QA_SCORECARD_CRITERIA_ARCHIVE = 'smart_qa_scorecard_criteria_archive',
  // Smart QA Wizard.
  SMART_QA_WIZARD_CONTINUE = 'smart_qa_wizard_continue',
  SMART_QA_WIZARD_CANCEL = 'smart_qa_wizard_cancel',
  SMART_QA_WIZARD_CREATE = 'smart_qa_wizard_create',
  // Smart QA Empty State.
  SMART_QA_EMPTY_STATE = 'smart_qa_empty_state',
  SMART_QA_SETUP_EMPTY_STATE = 'smart_qa_setup_empty_state',
}
